module.exports = __webpack_public_path__ + "static/media/analytics.51d658f7.svg";